import Picker from "better-picker";
import "@/scss/picker.scss";

class newPicker extends Picker {
	constructor(options) {
		super(options);
	}
	_bindEvent() {
		super._bindEvent();
		// 遮罩加点击关闭事件
		this.maskEl.addEventListener("click", () => {
			this.hide();
			this.trigger("picker.cancel");
		});
	}
	destroy() {
		this.pickerEl.parentNode.removeChild(this.pickerEl);
		return null;
	}
}

let cancelFn = function() {},
	changeFn = function(index, selectedIndex) {},
	selectFn = function() {},
	valueChangeFn = function() {};
const picker = {
	callbacks:{},
	init(
		options = {},
		callbacks = {
			cancelFn,
			changeFn,
			selectFn,
			valueChangeFn,
		},
	) {
		if (!this.instance) {
			this.instance = new newPicker(options);
			this.callbacks = callbacks;
			this.instance.on("picker.cancel", () => {
				this.callbacks.cancelFn && this.callbacks.cancelFn();
			});
			this.instance.on("picker.change", (index, selectedIndex)=> {
				this.callbacks.changeFn && this.callbacks.changeFn(index, selectedIndex);
			});
			this.instance.on("picker.select", (selectedVal, selectedIndex)=> {
				this.callbacks.selectFn && this.callbacks.selectFn(selectedVal, selectedIndex);
			});
			this.instance.on("picker.valuechange", (selectedVal, selectedIndex)=> {
				this.callbacks.valueChangeFn &&
					this.callbacks.valueChangeFn(selectedVal, selectedIndex);
			});
		} else {
			console.warn("picker已初始化");
		}
	},
	show(next) {
		this.instance.show(next);
	},
	refill(datas) {
		this.instance.refill(datas);
	},
	refillColumn(index, data) {
		this.instance.refillColumn(index, data);
	},
    scrollColumn(index, dist) {
        this.show(() => {
			this.instance.scrollColumn(index, dist);
		});
	},
	updateCallbacks(callbacks = { cancelFn, changeFn, selectFn, valueChangeFn }) {
		this.callbacks = callbacks;
	},
	destroy() {
		if (!this.instance) {
			console.error("picker未初始化");
			return;
		}
		this.instance.destroy();
		this.instance = null;
	},
};

const BetterPicker = {
	install: function(Vue) {
		Vue.prototype.$picker = picker;
	},
};

export default BetterPicker;
